import { Component,Output, EventEmitter } from "@angular/core";
import { AppService } from "../../services/app.service";
import { GenericResponseContract } from "projects/shared/models/GenericResponseContract";
import { Globals } from 'projects/shared/models/Globals';
import { Input } from "@angular/core";

declare var $: any;

//workaround for css content localization to be cleaned

@Component({
  selector: "map-filtration-box",
  templateUrl: "./map-filtration-box.component.html",
  styles: []
})

export class MapFiltrationBoxComponent {
  globals;
  filtrationBoxLists:any;
  selectedFilter='first';
  @Output() periodId = new EventEmitter();
  @Output() citiesIds=new EventEmitter();
  @Output() reset=new EventEmitter();

  _resultsCount;
  get resultsCount(): number { 
    return this._resultsCount;
  }
  @Input()
  set resultsCount(val: number) {
    this._resultsCount = val;
  }
  
  constructor(private  apiService:  AppService) { }

  ngOnInit() {
    this.globals=Globals;
    this.getFiltrationBoxLists();
  }

  public  getFiltrationBoxLists(){
    this.apiService.getFiltrationBoxLists().subscribe((response:  GenericResponseContract<object>) => {
        this.filtrationBoxLists  =  response.Data;
        if(this.filtrationBoxLists &&this.filtrationBoxLists.CitiesLookup && this.filtrationBoxLists.CitiesLookup[0] ){
          this.sendCitiesIds(this.filtrationBoxLists.CitiesLookup[0])
        }
    });    
  }

  sendPeriodId(id):void{
    this.resetMap('second');
    this.periodId.emit(id);
  }

  sendCitiesIds(item):void{
    item.checked=!item.checked;
    this.citiesIds.emit(item.ID);
  }

  resetMap(filter):void{
    this.filtrationBoxLists.CitiesLookup.forEach((item) => {
      item.checked = false;
    });
    $('.mapsListFiltration').removeClass('active'); //TODO: replace jquery code    
    this.selectedFilter=filter;
    this.reset.emit(true);
  }
}
